import { ComponentPropsWithRef, forwardRef } from "react";
import clsx from 'clsx';
import CardStyle from "./css/Card.module.css"
import BoxShadowProps from "./types/ui/boxShadow";
import BorderRadiusProps from "./types/ui/borderRadius";
import BorderProps from "./types/ui/border";
import transWidthHeight from "./utils/transWidthHeight";

export type CardProps = ComponentPropsWithRef<"div"> & BoxShadowProps & BorderRadiusProps & BorderProps & {
    gray?: boolean;
    fullWidth?: boolean;
    padding?: number;
    paddingX?: number;
    paddingY?: number;
    paddingLeft?: number;
    paddingRight?: number;
    paddingTop?: number;
    paddingBottom?: number;
    width?: number | string;
    height?: number | string;
    shadowAlpha?: number;
    backgroundColor?: string;
};

const Card = forwardRef<HTMLDivElement, CardProps>(({
    children,
    shadow = 12,
    shadowDirection = "default",
    gray = false,
    border = 1,
    borderRadius = 12,
    fullWidth = false,  
    padding,
    paddingX,
    paddingY,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    width,
    height,
    shadowAlpha = 0.08,
    backgroundColor,
    style,
    className,
    ...props
}, ref) => {
    const borderValue = border ? `${border}px solid rgba(221, 221, 221, 1)` : "none";
    const fullWidthValue = fullWidth ? "100%" : "fit-content";
    const widthValue = fullWidth ? fullWidthValue : transWidthHeight(width);
    const heightValue = transWidthHeight(height);
    const finalPaddingLeft = paddingLeft ?? paddingX ?? padding;
    const finalPaddingRight = paddingRight ?? paddingX ?? padding;
    const finalPaddingTop = paddingTop ?? paddingY ?? padding;
    const finalPaddingBottom = paddingBottom ?? paddingY ?? padding;
    return (
        <div
            ref={ref}
            className={clsx(
                CardStyle["card-container"],
                gray && CardStyle.gray,
                border && CardStyle.outline,
                className
            )}
            style={{ 
                boxShadow: `0 ${shadowDirection === "default" ? 0 : 4}px ${shadow}px rgba(0, 0, 0, ${shadowAlpha})`,
                borderRadius: `${borderRadius}px`,
                border: borderValue,
                width: widthValue,
                height: heightValue,
                paddingTop: finalPaddingTop && `${finalPaddingTop}px`,
                paddingBottom: finalPaddingBottom && `${finalPaddingBottom}px`,
                paddingLeft: finalPaddingLeft && `${finalPaddingLeft}px`,
                paddingRight: finalPaddingRight && `${finalPaddingRight}px`,
                backgroundColor: backgroundColor,
                ...style
            }}
            {...props}
        >
            {children}
        </div>
    )
});

Card.displayName = "Card";

export default Card;